// Shared text input used by SourcesTab, IslandEditModal, and AdForm.
export const Field = ({ label, value, onChange, testid, placeholder }) => (
  <div>
    <label className="block text-[11px] uppercase tracking-wider text-[#6B7280] mb-1">
      {label}
    </label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full bg-[#FAFAFA] rounded-lg px-3 py-2 text-[#1A1A1A] focus:bg-white focus:ring-2 focus:ring-[#0AADA0] focus:outline-none text-sm"
      data-testid={testid}
    />
  </div>
);
